import React from 'react';
import PropTypes from 'prop-types';
import { recordIntent, divIdNumToRPSMap } from '../../../lib/appcenterIntent';
import { clientLogger } from '../../../lib/logger';
import { CHECKOUT } from '../../../lib/constants';
import OptimizedImage from './OptimizedImage';
import DetailsTextContent from './DetailsText';
import {
  getExtraInfoContent,
  getDeveloperLinkContent,
  getImageButtonValues
} from '../lib/DetailsPhotoSectionHelper';
import { fireDetailsPageComponentFailureFpti } from '../../../lib/helpers';

class DetailsPhotoSections extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  handleClick = url => {
    const {
      componentContent: { toolKey = '' } = {},
      handleClickFPTI
    } = this.props;
    const number = this.ref.current.id.split('-').pop();
    const fptiLink = 'start_setup_' + number;
    handleClickFPTI(fptiLink);
    if (toolKey === CHECKOUT) {
      /* brittle, if the order of the rows change, the wrong intents are fired */
      /* ideal solution: move RPS product key to PS */
      const product = divIdNumToRPSMap[number];
      this.recordRPSIntent(product, url);
    } else {
      window.open(url, '_blank');
    }
  };

  recordRPSIntent = (product, url) => {
    const { app } = this.props;
    recordIntent({
      csrf: app.csrf,
      productArr: [product]
    }).finally(() => {
      window.location.href = url;
    });
  };

  addDevLink(event, linkUrl, handleClick) {
    if (event.target.classList.contains('add-dev-link')) {
      handleClick(linkUrl);
    }
  }

  render() {
    const {
      handleClickFPTI,
      componentContent,
      fptiImpression,
      toolName
    } = this.props;
    const {
      direction,
      imageUrl,
      subtitle,
      title,
      extraItem,
      imageButton,
      style
    } = componentContent;

    if (!title || !imageUrl || !subtitle || !direction) {
      fireDetailsPageComponentFailureFpti({
        data: { title, imageUrl, subtitle, direction },
        componentName: 'DetailsPhotoSection',
        fptiImpression
      });
      return null;
    }

    let styleObject = {};

    if (style) {
      try {
        styleObject = JSON.parse(style);
      } catch (error) {
        clientLogger.warn(
          `Corrupt JSON in the style object ${style}, Error : ${error}`
        );
      }
    }

    const extraInfo = getExtraInfoContent(extraItem);
    const developerLink = getDeveloperLinkContent(extraInfo);
    const imageButtonValues = getImageButtonValues(imageButton);

    return (
      <section id="details-options" ref={this.ref} style={styleObject}>
        <div
          className={`details-option-list-item${
            direction === 'rtl' ? '-rtl' : ''
          }`}
        >
          <DetailsTextContent
            title={title}
            subtitle={subtitle}
            direction={direction}
            extraInfo={extraInfo}
            buttonText={componentContent.buttonText}
            buttonUrl={componentContent.buttonUrl}
            linkText={componentContent.linkText}
            linkUrl={componentContent.linkUrl}
            imageButtonValues={imageButtonValues}
            developerLink={developerLink}
            handleClickFPTI={handleClickFPTI}
            handleClick={this.handleClick}
            addDevLink={this.addDevLink}
            toolName={toolName}
          />
          <div className="details-option-image-container">
            <OptimizedImage
              title={toolName}
              imageUrl={imageUrl}
              className={`details-option-image-tag`}
            />
          </div>
        </div>
      </section>
    );
  }
}

DetailsPhotoSections.propTypes = {
  componentContent: PropTypes.object,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
  direction: PropTypes.string,
  imageUrl: PropTypes.string,
  fptiImpression: PropTypes.func,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  extraItem: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  app: PropTypes.object,
  toolName: PropTypes.string
};

export default DetailsPhotoSections;
